import React from 'react';

interface BrandLogoProps {
  variant?: 'mark' | 'full';
  className?: string;
  alt?: string;
  loading?: 'eager' | 'lazy';
}

/** Both variants use the supplied artwork; intrinsic sizes preserve its proportions. */
export default function BrandLogo({ variant = 'mark', className = '', alt = 'G-Launcher', loading = 'eager' }: BrandLogoProps) {
  const full = variant === 'full';
  const source = `/brand/glauncher-${full ? 'logo' : 'mark'}`;
  return <picture className="contents">
    <source type="image/webp" srcSet={`${source}.webp`} />
    <img src={`${source}.png`} alt={alt} width={full ? 960 : 512} height={full ? 684 : 512}
      loading={loading} decoding="async" className={`block max-w-full object-contain ${className}`} />
  </picture>;
}
